<template>
  <div>
    <h1 class="title">COME CI HAI CONOSCIUTO?</h1>

    <p class="subtitle">
      Vogliamo sapere come hai scoperto di noi!
      <strong>Seleziona sotto un'opzione</strong>
    </p>

    <form class="form max-w-5xl mx-auto mt-4" @submit.prevent>
      <div class="form-group">
        <label class="form-label important-label"> Come ci hai conosciuto? </label>

        <v-select
          class="form-control"
          label="name"
          v-model.number="$v.form.knownThrough.$model"
          :reduce="(option) => option.id"
          :options="listData.howDidYouKnowUs"
        ></v-select>
        <div v-if="$v.form.knownThrough.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="knownThroughProfessional">
        <div class="form-group">
          <label class="form-label important-label" for="coupon_code">
            Inserisci qui il tuo codice
          </label>
          <div v-if="asyncState !== 'pending'">
            <input
              v-model="$v.form.couponCode.$model"
              type="text"
              placeholder=""
              class="form-control appearance-none"
              id="coupon_code"
            />
            <div
              v-if="$v.form.couponCode.$error && !$v.form.couponCode.required"
              class="error"
            >
              campo obbligatorio
            </div>
            <div v-if="showErrorMessage" class="error">{{ errorMessage }}</div>
          </div>
          <Loader :asyncState="asyncState"></Loader>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Loader from "./Loader";
import vSelect from "vue-select";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
    Loader,
  },
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      asyncState: null,
      errorMessage: "",
      form: {
        knownThrough: null,
        couponCode: null,
      },
    };
  },
  validations: {
    form: {
      knownThrough: {
        required,
      },
      couponCode: {
        required: requiredIf(function () {
          return this.knownThroughProfessional;
        }),
      },
    },
  },
  watch: {
    "form.knownThrough": function (after) {
      if (after != 1) {
        this.form.couponCode = null;
        this.setErrorMessage("");
      }
    },
  },
  computed: {
    showErrorMessage() {
      return this.errorMessage !== "";
    },
    knownThroughProfessional() {
      return this.form.knownThrough == 1;
    },
  },
  methods: {
    loaderAsyncState(state) {
      this.asyncState = state;
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            form: {
              knownThrough: this.form.knownThrough,
              couponCode: this.form.couponCode,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
    async getPrices() {
      this.$emit("barAsyncState", "pending");
      var updatedData = [];
      var dog = [];
      updatedData = Object.assign({}, this.wizardData);

      // get prices to only one dog if different diet
      // otherwise get prices to all
      if (this.wizardData.numberOfDogs >= 2 && !this.wizardData.sameDiet) {
        updatedData.numberOfDogs = 1;
        updatedData.dogs = [];
        dog = Object.assign(this.dogData, this.dog);
        updatedData.dogs.push(dog);
      } else if (this.wizardData.numberOfDogs >= 2 && this.wizardData.sameDiet) {
        // first needs to update all dogs with isDuplex:
        for (let i = 0; i < this.wizardData.numberOfDogs; i++) {
          Object.assign(updatedData.dogs[i], this.dog);
        }
      } else {
        Object.assign(updatedData.dogs[updatedData.indexDog], this.dog);
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          snakecaseKeys({
            form: updatedData,
            selectedRecipeId: this.dogData.recipeId,
          })
        ),
      };
      let url = this.$restAPIurlRB + "recipe-prices";
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      var camelcaseData = camelcaseKeys(data, { deep: true });
      this.prices = camelcaseData.recipes;

      this.$emit("prices", this.prices);
      this.$emit("barAsyncState", "success");
    },
  },
  activated() {
    this.form.knownThrough = this.wizardData.knownThrough;
    this.form.couponCode = this.wizardData.couponCode;
    this.$v.$reset();
    this.getPrices();
  },
  mounted() {
    this.getPrices();
  },
};
</script>
